import type { FunctionComponent } from "react";
import { PostRejectModalBrandPartial } from "../../../../partials/brand/menus/post/post-reject-modal.brand";

export const PostRejectModalBrandScreen: FunctionComponent = () => {
	return <PostRejectModalBrandPartial />;
};
